/**
 * @namespace
 * @global
 */
const Voter =
{
	USER_VOTE_DATA: 'user-vote',
	DISABLED_CLASS: 'disabled',
	VOTED_CLASS: 'voted',

	vote: function (link, userVote) {
		if ($(link).hasClass(Voter.DISABLED_CLASS)) {
			return;
		}

		if (!$(link).data(Voter.USER_VOTE_DATA)) {
			Voter._addVote(link, userVote);
		} else {
			Voter._removeVote(link);
		}
	},

	_addVote: function (link, userVote) {
		dataAction.callClientGetEndpoint(
			$(link).data("vote-endpoint"),
			function (votes) {
				Voter._updateUIAfterVote(link, userVote, votes);
			},
			Voter._errorHandler
		);
	},

	_removeVote: function (link) {
		dataAction.callClientGetEndpoint(
			$(link).data("remove-vote-endpoint"),
			function (votes) {
				Voter._updateUIAfterRemoveVote(link, votes);
			},
			Voter._errorHandler
		);
	},

	_updateUIAfterVote: function (link, userVote, votes) {
		const $link = $(link);
		const $toolbar = $link.closest(".toolbar");

		$link.data(Voter.USER_VOTE_DATA, userVote);

		$toolbar.find(".like, .dislike").addClass(Voter.VOTED_CLASS);

		if (userVote == 1) {
			$toolbar.find(".dislike").addClass(Voter.DISABLED_CLASS);
		} else {
			$toolbar.find(".like").addClass(Voter.DISABLED_CLASS);
		}

		Voter._updateDisplayedVotes($toolbar, votes);
	},

	_updateUIAfterRemoveVote: function (link, votes) {
		const $link = $(link);
		const $toolbar = $link.closest(".toolbar");

		$link.removeData(Voter.USER_VOTE_DATA);
		$link.removeAttr("data-" + Voter.USER_VOTE_DATA);
		
		$toolbar
			.find(".like, .dislike")
			.removeClass(Voter.VOTED_CLASS)
			.removeClass(Voter.DISABLED_CLASS);

		Voter._updateDisplayedVotes($toolbar, votes);
	},

	_updateDisplayedVotes: function ($toolbar, votes) {
		$toolbar.find(".dislike .votes").html(votes.dislikes);
		$toolbar.find(".like .votes").html(votes.likes);
	},

	_errorHandler: function (error) {
		showErrorPopup(error.responseJSON.message);
	},
};